var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"row",style:(_vm.styleTableObject),attrs:{"id":"tree-table-row","getKey":_vm.getKey}},[_vm._t("row-data")],2)}
var staticRenderFns = []

export { render, staticRenderFns }